import React from 'react';
import PropTypes from 'prop-types';

import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import { Button } from 'reactstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment-timezone';
import axios from 'axios';
import { API_HOST, HTTP_PROTOCOL } from '../../config';
// import DateTimePicker from 'react-datetime-picker';// Constants
// import { timeDiff } from '../../commons/constants';
import { isNull, isUndefined, isEmpty } from 'lodash';
import DmeDateTimePicker from '../DmeDateTimePicker';

class BidQuoteSlider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            formInputs: {
                // client_mu_1_minimum_values: 0,
                notes: '',
                pickup_timestamp: '',
                pickup_timestamp_2: '',
                delivery_timestamp: '',
                delivery_timestamp_2: '',
                packed_status: 'original',
                pu_time_1: 0,
                pu_min_1: 0,
                pu_time_2: 0,
                pu_min_2: 0,
                de_time_1: 0,
                de_min_1: 0,
                de_time_2: 0,
                de_min_2: 0,
            },
            disabled: false,
        };

        moment.tz.setDefault('Australia/Sydney');
        this.tzOffset = new Date().getTimezoneOffset() === 0 ? 0 : -1 * new Date().getTimezoneOffset() / 60;
        this.submitHandler = this.submitHandler.bind(this);
    }

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        token: PropTypes.string,
        quote: PropTypes.object,
        toggleSlider: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { isOpen, quote } = nextProps;

        if (!this.props.isOpen && isOpen) {
            let formInputs = {
                fee: 0,
                etd: 3,
                notes: '',
                pickup_timestamp: '',
                delivery_timestamp: '',
                pickup_timestamp_2: '',
                delivery_timestamp_2: '',
                mu_percentage_fuel_levy: 0,
                // client_mu_1_minimum_values: 0,
                packed_status: 'original',
                token: this.props.token,
                pu_time_1: 0,
                pu_min_1: 0,
                pu_time_2: 0,
                pu_min_2: 0,
                de_time_1: 0,
                de_min_1: 0,
                de_time_2: 0,
                de_min_2: 0,
            };

            if (quote) {
                formInputs = {
                    quote_id: quote.cost_id,
                    freight_provider: quote.fp_name,
                    fee: quote.cost_dollar,
                    etd: quote.eta.split(' ')[0],
                    mu_percentage_fuel_levy: quote.mu_percentage_fuel_levy,
                    notes: quote.notes,
                    pickup_timestamp: moment.parseZone(quote.pickup_timestamp).tz('Australia/Sydney').toString(),
                    pickup_timestamp_2: moment.parseZone(quote.pickup_timestamp_2).tz('Australia/Sydney').toString(),
                    delivery_timestamp: moment.parseZone(quote.delivery_timestamp).tz('Australia/Sydney').toString(),
                    delivery_timestamp_2: moment.parseZone(quote.delivery_timestamp_2).tz('Australia/Sydney').toString(),
                    client_mu_1_minimum_values: quote.client_mu_1_minimum_values,
                    packed_status: 'original',
                    token: this.props.token,
                    pu_time_1: moment.parseZone(quote.pickup_timestamp).tz('Australia/Sydney').hour(),
                    pu_min_1: moment.parseZone(quote.pickup_timestamp).tz('Australia/Sydney').minute(),
                    pu_time_2: moment.parseZone(quote.pickup_timestamp_2).tz('Australia/Sydney').hour(),
                    pu_min_2: moment.parseZone(quote.pickup_timestamp_2).tz('Australia/Sydney').minute(),
                    de_time_1: moment.parseZone(quote.delivery_timestamp).tz('Australia/Sydney').hour(),
                    de_min_1: moment.parseZone(quote.delivery_timestamp).tz('Australia/Sydney').minute(),
                    de_time_2: moment.parseZone(quote.pickup_timestamp_2).tz('Australia/Sydney').hour(),
                    de_min_2: moment.parseZone(quote.pickup_timestamp_2).tz('Australia/Sydney').minute()
                };
            }
            this.setState({ formInputs });
        }
    }

    notify = (text) => {
        toast(text);
    };

    onInputChange(event) {
        const { formInputs } = this.state;
        const target = event.target;
        const value = target.value;
        const name = target.name;
        formInputs[name] = value;
        this.setState({ formInputs });
    }

    onChangeDateTime(date, fieldName) {
        console.log(date);
        const { formInputs } = this.state;
        if (!date) {
            formInputs[fieldName] = null;
        } else {
            // let conveted_date = moment(date).add(this.tzOffset, 'h');           // Current -> UTC
            // conveted_date = conveted_date.add(timeDiff, 'h');                   // UTC -> Sydney
            formInputs[fieldName] = moment(date).format('YYYY-MM-DD HH:mmZ');
        }
        console.log(formInputs);
        this.setState({ formInputs });
    }

    submitHandler(e) {
        e.preventDefault();
        const { formInputs, disabled } = this.state;
        const { quote } = this.props;
        const pageType = this.props.location.pathname.split('/')[1];

        let _formInputs = { ...formInputs };
        let pickup_timestamp = moment.parseZone(_formInputs['pickup_timestamp']);
        let pickup_timestamp_1 = pickup_timestamp.hour(_formInputs['pu_time_1']).minute(_formInputs['pu_min_1']).format('YYYY-MM-DD HH:mmZ');
        let pickup_timestamp_2 = pickup_timestamp.hour(_formInputs['pu_time_2']).minute(_formInputs['pu_min_2']).format('YYYY-MM-DD HH:mmZ');
        _formInputs['pickup_timestamp'] = pickup_timestamp_1;
        _formInputs['pickup_timestamp_2'] = pickup_timestamp_2;

        let delivery_timestamp = moment.parseZone(_formInputs['delivery_timestamp']);
        let delivery_timestamp_1 = delivery_timestamp.hour(_formInputs['de_time_1']).minute(_formInputs['de_min_1']).format('YYYY-MM-DD HH:mmZ');
        let delivery_timestamp_2 = delivery_timestamp.hour(_formInputs['de_time_2']).minute(_formInputs['de_min_2']).format('YYYY-MM-DD HH:mmZ');
        _formInputs['delivery_timestamp'] = delivery_timestamp_1;
        _formInputs['delivery_timestamp_2'] = delivery_timestamp_2;


        if (pageType === 'bid-decline') {
            if (!confirm('Are you sure you want to decline the quote?')) {
                return;
            }

            _formInputs['etd'] = 0;
            _formInputs['client_mu_1_minimum_values'] = 0;

            let options = {
                method: quote ? 'put' : 'post',
                url: `${HTTP_PROTOCOL}://${API_HOST}/pricing/${quote ? 'editBid' : 'addBid'}/`,
                data: { ..._formInputs }
            };

            this.setState({ disabled: true });
            axios(options)
                .then(() => {
                    this.notify('Decline Quote has been successful');
                    this.setState({ disabled: false });
                    this.props.onSubmit();
                })
                .catch((error) => {
                    this.notify('Failed: ' + error);
                    this.setState({ disabled: false });
                });
        }

        if (disabled) {
            return;
        }

        if (_formInputs['pickup_timestamp'] > _formInputs['pickup_timestamp_2']) {
            this.notify('Failed: Input collection time correctly');
            return;
        }
        if (_formInputs['delivery_timestamp'] > _formInputs['delivery_timestamp_2']) {
            this.notify('Failed: Input delivery time correctly');
            return;
        }
        if (_formInputs['pickup_timestamp_2'] > _formInputs['delivery_timestamp']) {
            this.notify('Failed: Collection Time should be earlier than delivery time');
            return;
        }


        const now = new Date();

        // Extract date and time components
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
    
        // Combine into the desired format
        let tmpDate = `${year}-${month}-${day} ${hours}:${minutes}`;       

        if (_formInputs['pickup_timestamp'].substring(0,16) < tmpDate) {
            this.notify('Failed: Collection Time should not be earlier than current time');
            return;
        }

        if (_formInputs['client_mu_1_minimum_values'] <= 0) {
            this.notify('Please input the correct amount');
            return;
        }

        // Parse the date strings into Date objects
        const deliveryDate = new Date(_formInputs['delivery_timestamp'].replace(' ', 'T'));
        const pickupDate = new Date(_formInputs['pickup_timestamp'].replace(' ', 'T'));

        // Calculate the difference in milliseconds
        const timeDiff = deliveryDate - pickupDate;

        // Convert the difference to days (1 day = 86400000 milliseconds)
        const diffInDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1;

        _formInputs['etd'] = diffInDays;
        console.log(_formInputs);
        let options = {
            method: quote ? 'put' : 'post',
            url: `${HTTP_PROTOCOL}://${API_HOST}/pricing/${quote ? 'editBid' : 'addBid'}/`,
            data: { ..._formInputs }
        };

        this.setState({ disabled: true });
        axios(options)
            .then(() => {
                this.notify('Successfully Done!');
                window.alert('The quote has been successfully submitted.');
                this.setState({ disabled: false });
                this.props.onSubmit();
            })
            .catch((error) => {
                this.notify('Failed: ' + error);
                this.setState({ disabled: false });
            });

    }



    render() {
        const { isOpen, toggleSlider } = this.props;
        const { formInputs } = this.state;
        const pageType = this.props.location.pathname.split('/')[1];


        return (
            <SlidingPane
                className='bid-quote-slider'
                overlayClassName='bid-quote-overlay'
                isOpen={isOpen}
                title={'Bid Quote Slider'}
                subtitle='Form View'
                onRequestClose={toggleSlider}>
                <div className="slider-content">
                    {pageType === 'bid' ? (
                        <form onSubmit={this.submitHandler}>
                            <label>
                                <span>Collection Date</span>
                                {/* <DateTimePicker
                                    onChange={(date) => this.onChangeDateTime(date, 'pickup_timestamp')}
                                    value={(!isNull(formInputs['pickup_timestamp']) &&
                                        !isUndefined(formInputs['pickup_timestamp'])) ?
                                        new Date(moment(formInputs['pickup_timestamp']).toDate().toLocaleString('en-US', { timeZone: 'Australia/Sydney' })) : null
                                    }
                                    format={'dd/MM/yyyy HH:mm'}
                                /> */}
                                <DmeDateTimePicker
                                    onChange={(date) => this.onChangeDateTime(date, 'pickup_timestamp')}
                                    selected={(!isNull(formInputs['pickup_timestamp']) &&
                                        !isUndefined(formInputs['pickup_timestamp']) &&
                                        !isEmpty(formInputs['pickup_timestamp'])) ?
                                        // moment.tz(formInputs['pickup_timestamp'], 'Australia/Sydney').format('YYYY-MM-DD') : null
                                        new Date(moment(formInputs['pickup_timestamp']).toDate().toLocaleString('en-US', { timeZone: 'Australia/Sydney' })) : null
                                    }
                                    selectPastDates={false}
                                    selectTime={false}
                                />
                            </label><br />
                            <label>
                                <span>Collection Time</span>
                                <input
                                    className="datetime"
                                    required
                                    min="0"
                                    max="23"
                                    step="1"
                                    type="number"
                                    name="pu_time_1"
                                    value={formInputs['pu_time_1']}
                                    onChange={(e) => this.onInputChange(e)}
                                />
                                <input
                                    className="datetime"
                                    required
                                    min="0"
                                    max="59"
                                    step="1"
                                    type="number"
                                    name="pu_min_1"
                                    value={formInputs['pu_min_1']}
                                    onChange={(e) => this.onInputChange(e)}
                                />
                                <span className="datetime">:</span>
                                <input
                                    className="datetime"
                                    required
                                    min="0"
                                    max="23"
                                    step="1"
                                    type="number"
                                    name="pu_time_2"
                                    value={formInputs['pu_time_2']}
                                    onChange={(e) => this.onInputChange(e)}
                                />
                                <input
                                    className="datetime"
                                    required
                                    min="0"
                                    max="59"
                                    step="1"
                                    type="number"
                                    name="pu_min_2"
                                    value={formInputs['pu_min_2']}
                                    onChange={(e) => this.onInputChange(e)}
                                />
                            </label><br />
                            <label>
                                <span>Delivery Date</span>
                                {/* <DateTimePicker
                                    onChange={(date) => this.onChangeDateTime(date, 'delivery_timestamp')}
                                    value={(!isNull(formInputs['delivery_timestamp']) &&
                                        !isUndefined(formInputs['delivery_timestamp'])) ?
                                        new Date(moment(formInputs['delivery_timestamp']).toDate().toLocaleString('en-US', { timeZone: 'Australia/Sydney' })) : null
                                    }
                                    format={'dd/MM/yyyy HH:mm'}
                                /> */}
                                <DmeDateTimePicker
                                    onChange={(date) => this.onChangeDateTime(date, 'delivery_timestamp')}
                                    selected={(!isNull(formInputs['delivery_timestamp']) &&
                                        !isUndefined(formInputs['delivery_timestamp']) &&
                                        !isEmpty(formInputs['delivery_timestamp'])) ?
                                        new Date(moment(formInputs['delivery_timestamp']).toDate().toLocaleString('en-US', { timeZone: 'Australia/Sydney' })) : null
                                    }
                                    selectPastDates={false}
                                    selectTime={false}
                                />
                            </label><br />
                            <label>
                                <span>Delivery Time</span>
                                <input
                                    className="datetime"
                                    required
                                    min="0"
                                    max="23"
                                    step="1"
                                    type="number"
                                    name="de_time_1"
                                    value={formInputs['de_time_1']}
                                    onChange={(e) => this.onInputChange(e)}
                                />
                                <input
                                    className="datetime"
                                    required
                                    min="0"
                                    max="59"
                                    step="1"
                                    type="number"
                                    name="de_min_1"
                                    value={formInputs['de_min_1']}
                                    onChange={(e) => this.onInputChange(e)}
                                />
                                <span className="datetime">:</span>
                                <input
                                    className="datetime"
                                    required
                                    min="0"
                                    max="23"
                                    step="1"
                                    type="number"
                                    name="de_time_2"
                                    value={formInputs['de_time_2']}
                                    onChange={(e) => this.onInputChange(e)}
                                />
                                <input
                                    className="datetime"
                                    required
                                    min="0"
                                    max="59"
                                    step="1"
                                    type="number"
                                    name="de_min_2"
                                    value={formInputs['de_min_2']}
                                    onChange={(e) => this.onInputChange(e)}
                                />
                            </label><br />
                            <label>
                                <span>Total Cost inc. Fuel ex GST</span>
                                <input
                                    className="form-control"
                                    required
                                    step="0.01"
                                    type="number"
                                    name="client_mu_1_minimum_values"
                                    value={formInputs['client_mu_1_minimum_values']}
                                    onChange={(e) => this.onInputChange(e)}
                                />
                            </label><br />
                            <label>
                                <span>Anything we should know?</span>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="notes"
                                    value={formInputs['notes']}
                                    onChange={(e) => this.onInputChange(e)}
                                />
                            </label><br />
                            <label>
                                <Button type="submit primary" color="primary">Submit</Button>
                                <Button color="danger" onClick={toggleSlider}>Cancel</Button>
                            </label>
                        </form>
                    ) : (
                        <form onSubmit={this.submitHandler}>
                            <label>
                                <span>Reason</span>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="notes"
                                    value={formInputs['notes']}
                                    onChange={(e) => this.onInputChange(e)}
                                />
                            </label><br />
                            <label>
                                <Button type="submit primary" color="primary">Submit</Button>
                                <Button color="danger" onClick={toggleSlider}>Cancel</Button>
                            </label>
                        </form>
                    )}
                </div>
            </SlidingPane>
        );
    }
}

export default BidQuoteSlider;



// WEBPACK FOOTER //
// ./src/components/Sliders/BidQuoteSlider.js